<form [formGroup]="formGroup">
  <div class="{{ viewMode }}">
    <div class="grid grid-rows-3 mt-3">
      <div class="grid grid-cols-2 gap-10 justify-content-start items-center">
        <div class="w-full justify-self-start">
          <app-spec-dropdown
            id="spec-line-definition-application"
            [editMode]="editMode"
            [id]="'spec-line-definition-application'"
            [options]="applicationValues"
            [formGroup]="formGroup"
            [controlName]="'applicationDefinition'"
            [label]="translationService.translate('applicationText')"
          />
        </div>

        <div class="w-full justify-self-end">
          <app-dropdown-multiple-search
            id="sizes"
            [editMode]="editMode"
            [id]="'spec-line-definition-sizes'"
            [options]="sizesValues"
            [formGroup]="formGroup"
            [controlName]="'sizes'"
            [label]="translationService.translate('sizesText')"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-10 justify-content-start items-center">
        <div class="w-full justify-self-start">
          <app-dropdown-multiple-search
            id="makes"
            [editMode]="editMode"
            [id]="'spec-line-definition-makes'"
            [options]="makesValues"
            [formGroup]="formGroup"
            [controlName]="'makes'"
            [label]="translationService.translate('makesText')"
          />
        </div>

        <div class="w-full justify-self-end">
          <app-dropdown-multiple-search
            id="axle"
            [editMode]="editMode"
            [id]="'spec-line-definition-axles'"
            [options]="axleValues"
            [formGroup]="formGroup"
            [controlName]="'axles'"
            [label]="translationService.translate('axlesText')"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-10 justify-content-start items-center">
        <div class="w-full justify-self-start">
          <app-dropdown-multiple-search
            id="series"
            [editMode]="editMode"
            [id]="'spec-line-definition-series'"
            [options]="seriesValues"
            [formGroup]="formGroup"
            [controlName]="'series'"
            [label]="translationService.translate('seriesText')"
          />
        </div>

        @if (specLine.type !== SpecType.REPAIR_ONLY) {
        <div class="w-full justify-self-end">
          <app-dropdown-multiple-search
            id="treads"
            [editMode]="editMode"
            [id]="'spec-line-definition-tread'"
            [options]="treadsValues"
            [formGroup]="formGroup"
            [controlName]="'treads'"
            [label]="translationService.translate('treadsText')"
          />
        </div>
        }
      </div>
    </div>
  </div>
</form>
